// infoRekrutmen.js — Info & pengumuman resmi rekrutmen prajurit TNI AD
// Dipakai bareng di Beranda (ringkas) dan Profil > Notifikasi (lengkap),
// disatukan di sini supaya tidak ada dua salinan data yang bisa beda-beda.

export const INFO_REKRUTMEN = [
  {
    id: 1, tipe: 'penting', icon: '🚨', judul: 'Peringatan Penipuan Rekrutmen',
    isi: 'SELAMA PROSES PENERIMAAN BERLANGSUNG CALON TIDAK DIPUNGUT BIAYA APAPUN! Jika ada yang mengatasnamakan panitia untuk meminta sejumlah uang, itu PENIPUAN. Laporkan ke WA Panpus TNI AD: 0813-1050-0074',
    waktu: 'Penting', warna: '#F87171',
  },
  {
    id: 2, tipe: 'info', icon: '📢', judul: 'Tamtama & Bintara PK TNI AD Gelombang III TA 2026',
    isi: 'Pendaftaran Tamtama PK TNI AD Gelombang III TA 2026 TELAH DIBUKA (online mulai 15 Juli 2026), disusul Bintara PK Gelombang III (online mulai 17 Juli 2026) — keduanya sampai kuota pendaftar terpenuhi. Daftar online di: ad.rekrutmen-tni.mil.id. GRATIS — Tanpa dipungut biaya apapun.',
    waktu: 'Terkini · Gel III', warna: 'var(--accent)',
  },
  {
    id: 3, tipe: 'jadwal', icon: '📅', judul: 'Jadwal Seleksi Gelombang III 2026',
    isi: 'Tamtama: pendaftaran online mulai 15 Juli 2026, validasi mulai 17 Juli 2026. Bintara: pendaftaran online mulai 17 Juli 2026, validasi mulai 20 Juli 2026. Kuota bisa tertutup sewaktu-waktu. Jadwal seleksi lengkap disampaikan saat validasi/daftar ulang — pantau update di TikTok @panpustniad.',
    waktu: 'Gel III · 2026', warna: '#60A5FA',
  },
  {
    id: 4, tipe: 'syarat', icon: '📋', judul: 'Persyaratan Utama Tamtama TNI AD',
    isi: 'Pria WNI, usia 17 thn 10 bln – 24 thn 0 bln (per 16 Juli 2026). Ijazah min. SMA/MA/SMK. Tinggi badan min. 158 cm. Belum pernah menikah. Tidak bertato/tindik. Wajib punya BPJS/KIS aktif & SKCK dari Polres.',
    waktu: 'TA 2026', warna: '#A78BFA',
  },
  {
    id: 5, tipe: 'syarat', icon: '📋', judul: 'Persyaratan Tambahan Tamtama TNI AD',
    isi: 'Bersedia IDP minimal 10 tahun. Surat persetujuan orang tua/wali wajib. Tidak memiliki catatan kriminalitas. Sehat jasmani & rohani serta tidak berkacamata. Bersedia ditempatkan di seluruh wilayah NKRI.',
    waktu: 'TA 2026', warna: '#A78BFA',
  },
  {
    id: 6, tipe: 'tips', icon: '💡', judul: 'Pendaftaran Bintara PK TNI AD Gelombang III',
    isi: 'Tersedia jalur: Bintara Reguler Pria dan Bintara Reguler Wanita. Pendaftaran online Gelombang III sudah mulai 17 Juli 2026. Cek info lengkap persyaratan, jadwal, dan lokasi seleksi di ad.rekrutmen-tni.mil.id.',
    waktu: 'Info', warna: '#4ADE80',
  },
  {
    id: 7, tipe: 'tips', icon: '💡', judul: 'Tips Persiapan Psikotes Prajurit',
    isi: 'Kraepelin: fokus kecepatan dan konsistensi, latihan setiap hari minimal 15 menit. Kecermatan: perhatikan detail karakter mirip (l/I/1, 0/O). Kepribadian: jawab jujur sesuai kepribadian asli.',
    waktu: 'Tips', warna: '#FBBF24',
  },
];
